// extracted by mini-css-extract-plugin
module.exports = {"leftContainer":"sessionManager_leftContainer__19sum","label":"sessionManager_label__2UBVC","rightContainer":"sessionManager_rightContainer__BPOWj"};